/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name vcclient.factory:ClientService
   *
   * @description
   *
   */
  angular
    .module('vcclient')
    .factory('Client', Client)
    .config(config);
  
  
  config.$inject = ['restmodProvider'];
  
  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }
  
  
  Client.$inject = ['restmod'];
  
  function Client(restmod) {
    return restmod.model('/routes/clients', 'PagedModel').mix({
      // consults: {hasMany: 'Consult'},
      // reminders: {hasMany: 'Reminder'},
      // keywords: {hasMany: 'Keywords'},
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      test: {init: false},
      log: {init: []},
      primarycontact: {init: {}},
      companydata: {init: {}},
      image: {init: '/img/head_male.png'},
      inconsult: {inconsult: false},
      incheckout: {incheckout: false},
      consultstate: {consultstate: ''},
      checkoutstate: {checkoutstate: ''},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/clients/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      }// extend
    });
  }

}());